// extracted by mini-css-extract-plugin
export default {"message":"THDvEQWXInF6g37Ks0tt","messageBody":"_l9DEePyEjq0nXtzmFOH","posted":"l_ENwDoHUJCzszVbmCF1"};